import { useCallback } from 'react';
import BasicContainer from '@copilot/common/components/containers/basic';
import { CampaignType } from '@copilot/data/responses/interface';
import DeleteButton from '@copilot/common/components/button/delete';
import { CampaignSettingsLabels, deleteCampaign } from './helper';
import { useCanEditPermission } from '@copilot/common/hooks/permission';
import { PermissionName } from '@copilot/common/hooks/permission/interface';

type CampaignDashboardSettingsProps = {
    campaign: { id: string; type: CampaignType; organizationId: string; primaryColour: string };
    deleteCampaignCallback?: () => void;
};

/**
 * The Settings tab for a campaign
 * @param {object} campaign the current campaign
 * @param {function} deleteCampaignCallback called after a campaign gets deleted
 */
function CampaignDashboardSettings({
    campaign,
    deleteCampaignCallback,
}: CampaignDashboardSettingsProps) {
    const isSettingsEditable = useCanEditPermission(PermissionName.Settings);

    const handleDeleteCampaign = useCallback(() => {
        deleteCampaign(campaign.id, deleteCampaignCallback);
    }, [campaign.id, deleteCampaignCallback]);

    return (
        <BasicContainer>
            <BasicContainer.Header>Campaign Settings</BasicContainer.Header>
            <BasicContainer.Content>
                {isSettingsEditable && (
                    <DeleteButton
                        label={CampaignSettingsLabels.DeleteLabel}
                        confirmText={CampaignSettingsLabels.DeleteConfirm}
                        deleteAction={handleDeleteCampaign}
                    />
                )}
            </BasicContainer.Content>
        </BasicContainer>
    );
}

export default CampaignDashboardSettings;
